module.exports = __webpack_public_path__ + "img/CIO211_R.ea658002.png";